module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner_back"
  }, [_c('section', {
    attrs: {
      "id": "banner_back"
    }
  }, [_c('div', {
    staticClass: "inner_back"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6360e3b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BannerBack.vue
// module id = 162
// module chunks = 1